import DragDropFile from "@/components/global/DragDropFile.vue";
import { mapState, mapActions } from "vuex";
import { showError } from "@/helpers/globalHelpers";
import moment from "moment";
export default {
  name: "DetailActionPlanSatisFaction",

  data() {
    return {
      isLoading: false,
      tab: 0,
      periodHeaders: [
        { text: "Estado", sortable: false, value: "status" },
        { text: "Fecha de periodo", sortable: false, value: "register_date" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      factorHeaders: [
        { text: "Descripción", sortable: false, value: "description" },
        { text: "Peso", sortable: false, value: "weight" },
        { text: "Puntaje", sortable: false, value: "score" },
        { text: "Comentarios/Observaciones", sortable: false, value: "observations" },
        { text: "Ponderado", sortable: false, value: "pondered" },
      ],
      reportHeaders: [
        { text: "Año", sortable: false, value: "period" },
        { text: "Mes", sortable: false, value: "period_month" },
        {
          text: "Tareas programadas",
          sortable: false,
          value: "scheduledTasks",
        },
        { text: "Tareas ejecutadas", sortable: false, value: "executedTasks" },
        { text: "% de avance", sortable: false, value: "progress" },
      ],
      // Tus datos aquí
      evidences: [],
      years: [],
      filterYear: "",
      filterMonth: "",
      months: [
        { name: "ENERO", value: "January" },
        { name: "FEBRERO", value: "February" },
        { name: "MARZO", value: "March" },
        { name: "ABRIL", value: "April" },
        { name: "MAYO", value: "May" },
        { name: "JUNIO", value: "June" },
        { name: "JULIO", value: "July" },
        { name: "AGOSTO", value: "August" },
        { name: "SETIEMBRE", value: "September" },
        { name: "OCTUBRE", value: "October" },
        { name: "NOVIEMBRE", value: "November" },
        { name: "DICIEMBRE", value: "December" },
      ],
    };
  },

  computed: {
    breadcrumbs() {
      return [
        {
          text: "Inicio",
          link: true,
          exact: true,
          disabled: false,
          to: {
            name: "Dashboard",
          },
        },
        {
          text: "Lista de planes de acción por servicio",
          link: true,
          exact: true,
          disabled: false,
          to: {
            name: "ReportActionPlansSatisfaction",
          },
        },
        {
          text: "Detalle de agrupación de planes de acción por servicio",
          link: true,
          exact: true,
          disabled: false,
          to: {
            name: "DetailActionPlanSatisfactionGroupedService",
            params: { serviceId: this.$route.params.serviceId }
          },
        },
        {
          text: "Detalle de plan de acción",
          link: true,
          exact: true,
          disabled: true,
          to: {
            name: 'DetailActionPlanSatisfaction',
            params: { serviceId: this.$route.params.serviceId, actionPlanId: this.$route.params.actionPlanId }
          },
        },
      ];
    },
    ...mapState("action_plan", ["actionPlan"]),
    prepareFilterData() {

      const yearsSet = new Set(
        this.actionPlan?.generalProgress.monthlyProgress.map(
          (item) => item.period
        )
      );
      return (this.years = [...yearsSet]);
    },
    filteredMonthlyProgress() {

      // Verifica si ambos filtros están vacíos, y en ese caso, devuelve todos los datos.
      if (!this.filterYear && !this.filterMonth) {
        return this.actionPlan?.generalProgress?.monthlyProgress || [];
      }

      return (this.actionPlan?.generalProgress?.monthlyProgress || []).filter(item => {
        const matchesYear = this.filterYear ? item.period === this.filterYear : true;
        const matchesMonth = this.filterMonth ? item.period_month === this.filterMonth : true;
        return matchesYear && matchesMonth;
      });
    }
  },

  created() {
    this.getActionPlan();
  },

  methods: {
    // Tus métodos aquí
    ...mapActions("action_plan", ["getActionPlanById", "cleanActionPlanId"]),

    async getActionPlan() {
      this.isLoading = true;
      const { actionPlanId } = this.$route.params;
      const { error } = await this.getActionPlanById(actionPlanId);
      if (error) showError(error);
      this.isLoading = false;
    },

    setColorStatusActionPlan(status) {
      switch (status) {
        case "EN_CURSO":
          return {
            background: "blue lighten-5",
            color: "blue",
            name: "EN CURSO",
          };
        case "COMPLETADO":
          return {
            background: "green lighten-5",
            color: "green",
            name: status,
          };
        case "ATRASADO":
          return {
            background: "grey lighten-3",
            color: "grey",
            name: status,
          };
        case "ANULADO":
          return {
            background: "grey lighten-2",
            color: "grey",
            name: status,
          };
      }
    },

    setColorStatusEvidenceActionPlan(status) {
      switch (status) {
        case "EN_CURSO":
          return {
            background: "blue lighten-5",
            color: "blue",
            name: "EN CURSO",
          };
        case "COMPLETADO":
          return {
            background: "green lighten-5",
            color: "green",
            name: status,
          };
        case "ATRASADO":
          return {
            background: "grey lighten-3",
            color: "grey",
            name: status,
          };
        case "NO_COMPLETADO":
          return {
            background: "grey lighten-2",
            color: "grey",
            name: "NO COMPLETADO",
          };
        case "PENDIENTE":
          return {
            background: "blue lighten-5",
            color: "blue",
            name: "PENDIENTE",
          };
        case "OBSERVADO":
          return {
            background: "yellow lighten-4", 
            color: "yellow darken-2", 
            name: "OBSERVADO",
          };
      }
    },

    setNameMonth(month) {
      switch (month) {
        case 'January':
          return 'Enero'
        case 'February':
          return 'Febrero'
        case 'March':
          return 'Marzo'
        case 'April':
          return 'Abril'
        case 'May':
          return 'Mayo'
        case 'June':
          return 'Junio'
        case 'July':
          return 'Julio'
        case 'August':
          return 'Agosto'
        case 'September':
          return 'Setiembre'
        case 'October':
          return 'Octubre'
        case 'November':
          return 'Noviembre'
        case 'December':
          return 'Diciembre'
      }
    },

    formatDate(dateString) {
      // if (!dateString) {
      //   return { dateOnly: "-", isToday: false };
      // }
      // const formattedDateTime = moment(dateString).format("DD/MM/YYYY HH:mm");
      // const dateOnly = formattedDateTime.split(" ")[0];
      // const isToday = moment().format("DD/MM/YYYY") === dateOnly; // Comparar con la fecha actual

      // return { dateOnly, isToday };

      if (!dateString) {
        return "-";
      }
      // Trata la fecha como un objeto de fecha pura sin conversión de zona horaria
      const dateOnly = moment.utc(dateString).format("DD/MM/YYYY");

      return dateOnly;
    },
  },

  beforeDestroy() {
    this.cleanActionPlanId();
  },

  components: {
    DragDropFile,
  },
};
